import { ConfigService } from "./../Services/config.service";
import { TranslateService } from "@ngx-translate/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FatcaCrsService } from "./../Services/fatca-crs.service";
import { CountriesService } from "./../Services/countries.service";
import { Router } from "@angular/router";
import { CommonService } from "./../Services/common.service";
import { KycService } from "./../Services/kyc.service";
import { AuthService } from "./../Services/auth.service";
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Renderer2,
} from "@angular/core";
import { list } from "../SharedComponents/drop-down-list/drop-down-list.component";
import { Guid } from "guid-typescript";
import { ErrorMessageKeyService } from "../Services/error-message-key.service";
import { VideoCallService } from "../Services/video-call.service";

@Component({
  selector: "app-crsdeclaration",
  templateUrl: "./crsdeclaration.component.html",
  styleUrls: ["./crsdeclaration.component.scss"],
})
export class CRSdeclarationComponent implements OnInit {
  customSelectBox;

  @ViewChild("modal") Modal: ElementRef;

  @ViewChild("modal2") Modal2: ElementRef;
  @ViewChild("modal4") Modal4: ElementRef;

  counter: string;
  current: string;
  max: string;
  Userobj;
  selectedcountryValue: string = null;
  selectedCurrentCountry: string = "";

  dropdownlist: list[] = [];

  tinStatus: boolean = false;
  reasonStatus: boolean = false;
  reasonBStatus: boolean = false;
  newform: FormGroup;
  radioCheckStatus: null;
  radioCheckStatus2: null;
  radiobuttonValue: string = "";
  Termsandconditions: boolean = true;
  residentPakistani: boolean = true;
  consent: boolean = true;
  w8Form: boolean = false;

  constructor(
    public Renderer2: Renderer2,
    public auth: AuthService,
    public kyc: KycService,
    public config: ConfigService,
    public common: CommonService,
    private _router: Router,
    public country: CountriesService,
    public fatcaserv: FatcaCrsService,
    public formbuilder: FormBuilder,
    public errorKey: ErrorMessageKeyService,
    public translate: TranslateService,
    public Videoservice: VideoCallService
  ) {
    this.newform = this.formbuilder.group({
      _tinNumber: [""],
      _reasonExplanation: [""],
    });
  }
  getMessage(key, control) {
    let error = "";

    this.translate.get([key]).subscribe((data) => {
      error = data[key];
    });
    return error;
  }
  showFatcaDoc: boolean = false;
  async ngOnInit(): Promise<void> {
    this.counter = "4";
    this.current = "4";
    this.max = "4";

    this.auth.accessToken = await this.auth.Get("token");
    // var object = JSON.parse(await this.common.Get('User'));

    let data = await this.common.Get("FatcaObject");
    console.log(data, "FatcaObject")
    /*if (!data) {
      // this._router.navigateByUrl("/register/" + "CrsFatcaDeclaration");
    } else {
      this.fatcaserv.dataobject = JSON.parse(data);
      if (this.fatcaserv.dataobject.W8?.Name) {
        console.log(this.fatcaserv.dataobject.W8?.Name, "this.fatcaserv.dataobject.W8")
        this.fatcadoc = "W-8 BEN Form";
        this.showFatcaDoc = true;
      }
      if (this.fatcaserv.dataobject.W9?.Name) {
        this.fatcadoc = "W-9 Form";
        this.showFatcaDoc = true;
      }
    }*/
    // this.auth.data.onBoardingAccount.productId = object.onBoardingAccount.productId;

    debugger;
    await this.common.presentLoading();
    this.auth.verifyToken(this.auth.accessToken).then(async (data1: any) => {
      console.log(data1, "verifyToken");
      if (data1?.response?.code == 1) {
        this.kyc.count = 0;
        this.fatcaserv.dataobject.CrsList = []
        await this.country
          .GetAll(Guid.create().toString())
          .then(async (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                  this.country.countries = data.response.content;
                  this.dropdownlist = this.country.countries.map((x) => ({
                    value: x,
                    displayValue: x.countryName,
                    iconClass: x.flagClass,
                  }));
                  this.auth
                    .GetCRSList(
                      this.auth.accessToken,
                      this.auth.data.onBoardingAccount.applicationId
                    )
                    .then(async (data: any) => {
                      if (data?.response?.code == 1) {
                        this.auth.CRSData = data.response?.content;
                        console.log(
                          "CRSLIST",
                          JSON.stringify(this.auth.CRSData)
                        );
                        debugger;
                        if (this.auth.CRSData.length > 0) {
                          this.auth.CRSData.forEach((data) => {
                            let coun = this.country.countries.find(
                              (x) => x.isoCode3 == data.taxCountry
                            );
                            this.fatcaserv.dataobject.CrsList.push({
                              Reason: data.reason,
                              ReasonExplantion: data.reasonExplantion,
                              TaxCountry: data.taxCountry,
                              TaxCountryName: coun.countryName,
                              TinAvailable: data.tinAvailable,
                              TinNumber: data.tinNumber,
                            });
                          });
                          this.crsdeclaration = true;
                          this.Termsandconditions = true;
                          this.residentPakistani = true;
                          this.consent = true;
                          if (this.fatcaserv.dataobject.W8?.Name) {
                            this.fatcadoc = "W-8 BEN Form";
                            this.showFatcaDoc = true;
                            this.w8Form = true;
                          }
                          if (this.fatcaserv.dataobject.W9?.Name) {
                            this.fatcadoc = "W-9 Form";
                            this.showFatcaDoc = true;
                            this.w8Form = true;
                          }
                        }
                        this.common.hideLoading();
                      } else {
                        await this.common.hideLoading();
                        this.common.ParseErrorAlert("", "", this._router, data);
                      }
                    });
                  // await this.common.hideLoading();
                } else {
                  this.common.ParseErrorAlert("", "", this._router, data);
                }
              } else {
                this.common.ParseErrorAlert("", "", this._router, data);
              }
            } else {
              this.common.ParseErrorAlert("", "", this._router, data);
            }
          });
      } else {
        this.common.hideLoading();
        this.common.ParseErrorAlert("", "", this._router, data1);
      }
    });

    //  this.Userobj = JSON.parse(await this.common.Get('User'));
  }

  labelLink(e) {
    e.preventDefault();
    window.open("assets/CRS_Declaration.pdf", "_blank");
    // this.showPopup2();
  }

  showPopup() {
    if (this.fatcaserv.dataobject.W8.Name || this.fatcaserv.dataobject.W9.EntityName || this.fatcaserv.dataobject.CrsList.length > 0) {
      this.isCurrentTinAvailable = "";
      this.currentTinNumber = "";
      this.tinNumber = "";
      this.reason = "";
      this.reasonExplanation = "";
      this.selectedCurrentCountry = "";
      this.selectedcountryValue = "";
      this.Renderer2.addClass(this.Modal.nativeElement, "active");
      this.radioCheckStatus = null;
      this.radioCheckStatus2 = null;
      this.radiobuttonValue = "";
      this.reasonStatus = false;
      this.tinStatus = false;
    } else {
      this.isCurrentTinAvailable = "Yes";
      this.currentTinNumber = this.auth.data.idNumber;
      this.tinNumber = this.auth.data.idNumber;
      this.reason = "";
      this.reasonExplanation = "";
      this.selectedCurrentCountry = "Pakistan";
      this.selectedcountryValue = "PAK";
      this.Renderer2.addClass(this.Modal.nativeElement, "active");
      this.radioCheckStatus = null;
      this.radioCheckStatus2 = null;
      this.radiobuttonValue = "Yes";
      this.reasonStatus = false;
      this.tinStatus = true;
      this.tinStatusChange();
    }

  }
  hidePopup() {
    this.Renderer2.removeClass(this.Modal.nativeElement, "active");
  }
  isCurrentTinAvailable: string = "";
  currentTinNumber: string = "";
  tinNumber: string = "";
  reason: string = "";
  reasonExplanation: string = "";

  onCountryChange(event) {
    this.selectedcountryValue = event.value.isoCode3;
    this.selectedCurrentCountry = event.displayValue;
  }
  HasCountry(event, hasCountry) { }
  tinStatusChange() {
    this.isCurrentTinAvailable = "Yes";

    this.reasonStatus = false;
    this.tinStatus = true;

    let con = this.newform.controls["_tinNumber"];
    con.clearValidators();
    con.reset();
    con.setValidators(
      Validators.compose([
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(20),
        Validators.pattern("[a-zA-z0-9]*"),
      ])
    );
    con.markAsUntouched();
  }
  crsdeclaration: boolean = true;
  checked(event) {
    this.crsdeclaration = event.target.checked ? true : false;
  }
  isMainValid() {
    console.log(this.fatcaserv.dataobject.CrsList, this.showFatcaDoc, this.w8Form, "this.fatcaserv.dataobject.CrsList")
    /* if (
       this.crsdeclaration
       &&
       this.Termsandconditions &&
       this.residentPakistani &&
       this.consent
     ) {
       if (this.fatcaserv.dataobject.CrsList.length > 0) {
         if (this.showFatcaDoc) {
           if (this.w8Form) {
             return false;
           } else {
             return true;
           }
         } else {
           return false;
         }
       } else {
         return true;
       }
     } else {
       return true;
     }*/

    if (this.fatcaserv.dataobject.CrsList.length > 0) {
      if (this.showFatcaDoc) {
        if (this.w8Form) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  reasonStatusChange() {
    debugger;
    this.isCurrentTinAvailable = "No";

    this.reasonStatus = true;
    this.tinStatus = false;

    let con = this.newform.controls["_tinNumber"];

    con.clearValidators();
    con.reset();
    con.setValidators(Validators.compose([]));
    con.markAsUntouched();
  }
  DataSelected() {
    this.fatcaserv.dataobject.CrsList.push({
      Reason: this.reason,
      ReasonExplantion: this.reasonExplanation,
      TaxCountry: this.selectedcountryValue,
      TaxCountryName: this.selectedCurrentCountry,
      TinAvailable: this.isCurrentTinAvailable,
      TinNumber: this.tinNumber,
    });
    console.log(this.fatcaserv.dataobject.CrsList, "this.fatcaserv.dataobject.CrsList")
    this.Renderer2.removeClass(this.Modal.nativeElement, "active");
  }

  saveinfo() {
    var object = this.fatcaserv.dataobject;
    object.Crsconfirm = this.crsdeclaration;
    object.termsandcondition = this.Termsandconditions;
    object.residentPakistani = this.residentPakistani;
    object.consent = this.consent;
  }

  formpost() {
    this.common.presentLoading();
    this.saveinfo();
    /*if (
      this.Termsandconditions &&
      this.crsdeclaration &&
      this.residentPakistani &&
      this.consent
    ) {
      console.log(this.fatcaserv.dataobject, "this.fatcaserv.dataobject")
      this._router.navigateByUrl("/register/SupportingDocuments");
    } else {
      this.translate
        .get(["Sorry", "checkConfirmation", "OK"])
        .subscribe((data) => {
          this.common
            .showErrorAlert(
              data.Sorry,
              data.checkConfirmation,
              data.OK,
              this._router
            )
            .then((data: any) => { });
        });
    }*/
    console.log(this.fatcaserv.dataobject, "this.fatcaserv.dataobject")
    this._router.navigateByUrl("/register/SupportingDocuments");
  }

  formpostdolater() {
    this.common.showDoLaterAlert(this._router).then((data) => {
      if (data == "Logout") {
        this.common.presentLoading();
        this.saveinfo();
        if (
          this.Termsandconditions &&
          this.crsdeclaration &&
          this.residentPakistani &&
          this.consent
        ) {
          this.fatcaserv

            .CreatingFatcaCrsResponse(
              this.auth.accessToken,
              this.fatcaserv.dataobject
            )
            .then((data: any) => {
              console.log("fatcaserv", data);

              debugger;
              if (data?.response?.code == 1) {
                this.common.hideLoading();
                this.common.clear();
                this._router.navigateByUrl("/MobileVerification");
              } else {
                this.common.hideLoading();
                this.common.ParseErrorAlert("", "", this._router, data);
              }
            });
        }
        else {
          this.translate
            .get(["Sorry", "checkConfirmation", "OK"])
            .subscribe((data) => {
              this.common
                .showErrorAlert(
                  data.Sorry,
                  data.checkConfirmation,
                  data.OK,
                  this._router
                )
                .then((data: any) => { });
            });
        }
      }
    });
  }
  isValid() {
    if (!this.newform.valid) {
      return true;
    } else {
      if (this.selectedcountryValue) {
        if (this.isCurrentTinAvailable == "Yes") {
          if (this.tinNumber) {
            return false;
          } else {
            return true;
          }
        } else if (this.isCurrentTinAvailable == "No") {
          if (this.reason == "Reason A" || this.reason == "Reason C") {
            return false;
          } else if (this.reason == "Reason B") {
            if (this.reasonExplanation) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  }
  radioStatusChange(num) {
    this.reason = "";
    this.reasonExplanation = "";
    if (num == 1) {
      this.reason = "Reason A";
    } else if (num == 2) {
      this.reason = "Reason B";
    } else {
      this.reason = "Reason C";
    }
    if (num == 2) {
      this.reasonBStatus = true;
      let con = this.newform.controls["_reasonExplanation"];
      con.clearValidators();
      con.reset();
      con.setValidators(
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(30),
        ])
      );
      con.markAsUntouched();
    } else {
      this.reasonBStatus = false;
      let con = this.newform.controls["_reasonExplanation"];
      con.clearValidators();
      con.reset();
      con.setValidators(Validators.compose([]));
      con.markAsUntouched();
    }
  }

  showPopup2() {
    this.Renderer2.addClass(this.Modal2.nativeElement, "active");
  }
  hidePopup2() {
    this.Renderer2.removeClass(this.Modal2.nativeElement, "active");
  }
  remove(index) {
    this.fatcaserv.dataobject.CrsList.splice(index, 1);
  }

  hidePopup3() {
    this.Renderer2.removeClass(this.Modal4.nativeElement, "active");
  }
  fatcadoc: string = "";

  Selectedoption = undefined;
  customSelectBoxBtn(value) {
    this.customSelectBox = value;

    if (value == 1) {
      this.Selectedoption = "Yes";
    } else {
      this.Selectedoption = "No";
    }
  }

  isvalidbutton() {
    if (this.Selectedoption) {
      return false;
    } else {
      return true;
    }
  }

  VideoCallPost() {
    this.common.presentLoading();
    this.Videoservice.Videocallrequest(
      this.auth.accessToken,
      this.Selectedoption
    ).then((data: any) => {
      if (data?.response?.code == 1) {
        this.common.hideLoading();
        this.Renderer2.removeClass(this.Modal4.nativeElement, "active");
      } else {
        this.common.hideLoading();
        this.common.ParseErrorAlert("", "", this._router, data);
      }
    });
  }

  checked2(event) {
    this.Termsandconditions = event.target.checked ? true : false;
  }
  checked3(event) {
    this.residentPakistani = event.target.checked ? true : false;
  }
  checked4(event) {
    this.consent = event.target.checked ? true : false;
  }

  checked5(event) {
    this.w8Form = event.target.checked ? true : false;
  }

  labelLink2(e) {
    e.preventDefault();
    let file = this.auth.data.onBoardingAccount.pdfname;
    window.open("~/../assets/" + file, "_blank");
    console.log('pdffilename', file);
  }

  labelLink3(e) {
    e.preventDefault();
    window.open("~/../assets/Declaration-of-resident-pakistani.pdf", "_blank");
  }

  labelLink4(e) {
    e.preventDefault();
    window.open("~/../assets/Digital-Account-Opening-Consent.pdf", "_blank");
  }

  async labelLink5(e) {
    e.preventDefault();
    await this.common.presentLoading();
    this.fatcaserv
      .GetFatcaPDFDOC(this.auth.accessToken, this.fatcaserv.dataobject)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          await this.common.hideLoading();
          const pdfWindow = window.open("");
          pdfWindow.document.write(
            `<body style="margin: 0;">
          <iframe width='100%' height='100%' style="border: none;" src='data:application/pdf;base64,${encodeURI(
              data.response.content
            )}''></iframe></body>`
          );
        } else {
          this.common.ParseErrorAlert("", "", this._router, data);
        }
      });
  }
}
